import { promoConstants } from "../constants/promoConstants";
import { promoService } from "../../services/API/promoService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const promoActions = {
  add_promo,
  getPromoList,
  deletePromo,
  getPromoDetails,
  update_promo
};

export const add_promo = postData => {
  return dispatch => {
    promoService.add_promo(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: promoConstants.ADD_PROMO_REQUEST, data };
  }
  function success(data) {
    return { type: promoConstants.ADD_PROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: promoConstants.ADD_PROMO_FAILURE, error };
  }
};

export const getPromoList = formData => {
  return dispatch => {
    promoService.getPromoList(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: promoConstants.GET_PROMO_REQUEST, data };
  }
  function success(data) {
    return { type: promoConstants.GET_PROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: promoConstants.GET_PROMO_FAILURE, error };
  }
};

export const deletePromo = promoIDParam => {
  return dispatch => {
    promoService.deletePromo(promoIDParam).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: promoConstants.DELETE_PROMO_REQUEST, data };
  }
  function success(data) {
    return { type: promoConstants.DELETE_PROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: promoConstants.DELETE_PROMO_FAILURE, error };
  }
};

export const getPromoDetails = promoIdParams => {
  return dispatch => {
    promoService.getPromoDetails(promoIdParams).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: promoConstants.GET_PROMODETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: promoConstants.GET_PROMODETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: promoConstants.GET_PROMODETAIL_FAILURE, error };
  }
};

export const update_promo = postData => {
  return dispatch => {
    promoService.update_promo(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: promoConstants.UPDATE_PROMO_REQUEST, data };
  }
  function success(data) {
    return { type: promoConstants.UPDATE_PROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: promoConstants.UPDATE_PROMO_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/promoActions.js